import React, { useEffect, useRef, useState } from "react";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import JoditEditor from "jodit-react";
import axios from "axios";

function EditPage() {
  const editor = useRef(null);
  const token = sessionStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const [formdata, setFormdata] = useState({
    title: "",
    description: "",
  });

  useEffect(() => {
    const fetchSinglePage = async () => {
      if (!token) {
        toast.error("No token provided!");
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_APIURL}api/page/details/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response?.data?.data) {
          setFormdata({
            title: response?.data?.data?.title,
            description: response?.data?.data?.description,
          });
        }
      } catch (error) {
        toast.error(
          "Error fetching data: " +
            (error.response?.data?.message || error.message)
        );
      }
    };

    fetchSinglePage();
  }, [id, token]);

  const handleChange = (e) => {
    setFormdata({ ...formdata, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_APIURL}api/page/update/${id}`,
        {
          method: "PUT", // Fix: Use uppercase
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formdata), // Ensure valid JSON
        }
      );

      const data = await response.json(); // Parse response safely

      if (response.ok) {
        toast.success("Page updated successfully!");
        navigate("/page/list"); // Fix: Ensure correct route
        setFormdata({ title: "", description: "" });
      } else {
        toast.error(data.message || "Failed to update page");
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Pages</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Update Page</li>
            </ol>
          </nav>
        </div>

        <div className="card">
          <div className="card-body">
            <form className="row g-3 pt-4" onSubmit={handleSubmit}>
              <div className="col-md-6">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Enter Title Name"
                    name="title"
                    value={formdata.title}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="name">Page Name</label>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-control mb-3">
                  <label htmlFor="floatingTextarea">Description</label>
                  <JoditEditor
                    className="mt-2"
                    ref={editor}
                    value={formdata.description}
                    onChange={(content) =>
                      setFormdata({ ...formdata, description: content })
                    }
                  />
                </div>
              </div>

              <div className="text-start d-flex gap-3 mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Updateing..." : "Update Page"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
}

export default EditPage;
